// Live showroomstatus uit de global "Openingstijden" (business_hours).
// De data staat als JSON in de layout (#renoco-data); alle statusregels op de
// site (kopbalk, hero, footer, boekingspaneel) lezen uit deze ene store.

const WEEKDAGEN = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
import { t } from './taal';

// De naam van een weekdag aan het begin van een zin, in de taal van de pagina.
const dagnaam = (weekdag) => ({
    sunday: t('Zondag'),
    monday: t('Maandag'),
    tuesday: t('Dinsdag'),
    wednesday: t('Woensdag'),
    thursday: t('Donderdag'),
    friday: t('Vrijdag'),
    saturday: t('Zaterdag'),
})[weekdag];

function nuInAmsterdam() {
    const delen = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Amsterdam',
        weekday: 'long',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    }).formatToParts(new Date());

    const deel = (type) => delen.find((d) => d.type === type)?.value ?? '';

    return {
        weekdag: deel('weekday').toLowerCase(),
        minuten: parseInt(deel('hour'), 10) * 60 + parseInt(deel('minute'), 10),
    };
}

function naarMinuten(tijd) {
    const [uur, minuut] = String(tijd || '0:0').split(':').map(Number);
    return uur * 60 + (minuut || 0);
}

export function leesRenocoData() {
    try {
        return JSON.parse(document.getElementById('renoco-data')?.textContent || '{}');
    } catch (e) {
        return {};
    }
}

export default function maakOpeningstijden(data) {
    const dagen = Array.isArray(data?.openingstijden) ? data.openingstijden : [];

    const zoekDag = (weekdag) => dagen.find((d) => (d.weekday?.value ?? d.weekday) === weekdag);

    return {
        klaar: false,
        open: false,
        tekst: '',
        kort: '',
        vandaag: null,

        init() {
            this.bereken();
            setInterval(() => this.bereken(), 60 * 1000);
        },

        bereken() {
            if (!dagen.length) {
                this.klaar = false;
                return;
            }

            const nu = nuInAmsterdam();
            const vandaag = zoekDag(nu.weekdag);
            this.vandaag = vandaag ?? null;

            if (vandaag?.open && nu.minuten >= naarMinuten(vandaag.start_time) && nu.minuten < naarMinuten(vandaag.end_time)) {
                this.open = true;
                this.tekst = t('Vandaag open tot :tijd', { tijd: vandaag.end_time });
                this.kort = t('Open tot :tijd', { tijd: vandaag.end_time });
                this.klaar = true;
                return;
            }

            this.open = false;

            if (vandaag?.open && nu.minuten < naarMinuten(vandaag.start_time)) {
                this.tekst = t('Vandaag open vanaf :tijd', { tijd: vandaag.start_time });
                this.kort = t('Open vanaf :tijd', { tijd: vandaag.start_time });
                this.klaar = true;
                return;
            }

            const index = WEEKDAGEN.indexOf(nu.weekdag);
            for (let stap = 1; stap <= 7; stap++) {
                const weekdag = WEEKDAGEN[(index + stap) % 7];
                const dag = zoekDag(weekdag);
                if (dag?.open) {
                    const wanneer = stap === 1 ? t('Morgen') : dagnaam(weekdag);
                    this.tekst = t('Nu gesloten · :dag open vanaf :tijd', { dag: wanneer, tijd: dag.start_time });
                    this.kort = t(':dag vanaf :tijd', { dag: wanneer, tijd: dag.start_time });
                    this.klaar = true;
                    return;
                }
            }

            this.tekst = t('Nu gesloten');
            this.kort = t('Gesloten');
            this.klaar = true;
        },
    };
}
